"use strict";

export default () => null;
//# sourceMappingURL=BottomSheetFlashList.web.js.map